<template>
  <div>
      <register-ctrl :projectName="projectName" :projectLogo="projectLogo" @registerButtonClick="registerButtonClick" @loginTextClick="loginTextClick"></register-ctrl>
</div>
</template>
<script>
import RegisterCtrl from '../Ctrl/RegisterCtrl.vue'
// import { LoginLogic } from '../Logic/LoginLogic.js'
export default {
  data () {
    return {
      projectName: '项目名称',
      projectLogo: require('../../../Resource/Image/logo.png'),
      username: '',
      password: ''
    }
  },
  components: { RegisterCtrl },
  methods: {
    registerButtonClick () {
      this.$message('免费注册')
    },
    loginTextClick () {
      this.$emit('loginTextClick')
    }
  }
}
</script>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Area/RegisterArea.vue